/**
 * BlogContent - Wrapper for MDX content with prose styling
 */

interface BlogContentProps {
  children: React.ReactNode;
}

export function BlogContent({ children }: BlogContentProps) {
  return <div className="prose-jumpbean max-w-none">{children}</div>;
}
